import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import api from '../../services/api';

export default function VerifyEmailBanner() {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(
    sessionStorage.getItem('verifyBannerDismissed') === 'true'
  );
  const [resendStatus, setResendStatus] = useState('idle'); // idle | sending | sent | error

  if (!user || user.isVerified || dismissed) return null;

  const handleResend = async () => {
    setResendStatus('sending');
    try {
      await api.post('/auth/resend-verification');
      setResendStatus('sent');
      setTimeout(() => setResendStatus('idle'), 3000);
    } catch {
      setResendStatus('error');
      setTimeout(() => setResendStatus('idle'), 3000);
    }
  };

  const handleDismiss = () => {
    sessionStorage.setItem('verifyBannerDismissed', 'true');
    setDismissed(true);
  };

  return (
    <div className="bg-amber-900/30 border-b border-amber-500/50 px-4 py-2 flex items-center justify-between text-sm">
      <span className="text-amber-200">
        Please verify your email to unlock broker sync. Check your inbox.
      </span>
      <div className="flex items-center gap-3 ml-4 shrink-0">
        <button
          onClick={handleResend}
          disabled={resendStatus === 'sending'}
          className="text-amber-300 hover:text-amber-100 underline disabled:opacity-50"
        >
          {resendStatus === 'sending'
            ? 'Sending...'
            : resendStatus === 'sent'
            ? 'Email sent!'
            : resendStatus === 'error'
            ? 'Failed — try again'
            : 'Resend email'}
        </button>
        <button onClick={handleDismiss} className="text-amber-400 hover:text-amber-200 ml-1">
          &#x2715;
        </button>
      </div>
    </div>
  );
}
